"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _CompanyRecord = _interopRequireDefault(require("customer-data-objects/company/CompanyRecord"));

var _ContactRecord = _interopRequireDefault(require("customer-data-objects/contact/ContactRecord"));

var _DealRecord = _interopRequireDefault(require("customer-data-objects/deal/DealRecord"));

var _TicketRecord = _interopRequireDefault(require("customer-data-objects/ticket/TicketRecord"));

var _VisitRecord = _interopRequireDefault(require("customer-data-objects/visit/VisitRecord"));

var _default = _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_CompanyRecord.default).isRequired, _react.PropTypes.instanceOf(_ContactRecord.default).isRequired, _react.PropTypes.instanceOf(_DealRecord.default).isRequired, _react.PropTypes.instanceOf(_VisitRecord.default).isRequired, _react.PropTypes.instanceOf(_TicketRecord.default).isRequired]);

exports.default = _default;
module.exports = exports.default;